import { teceoBlueBackground, teceoGraySecondary, teceoGreen, teceoOrange } from '../Theme';
import { UseListPickActions } from '../components/ListPicker/useListPick.types';
import { UserRole } from '../modules/users/roles';
import { OnScrollEndReloadForUseInfinityListParams } from './types/generics.types';

interface GetColorByRoleParams {
  userRole?: UserRole;
  withSrc?: boolean;
  transparentWhenHasSrc?: boolean;
}

export const getColorByRole = ({
  userRole,
  withSrc,
  transparentWhenHasSrc = true,
}: GetColorByRoleParams) => {
  if (!userRole) {
    return teceoGraySecondary;
  }

  if (withSrc && transparentWhenHasSrc) {
    return 'transparent';
  }

  switch (userRole) {
    case 'ADMIN':
      return teceoOrange;
    case 'ADMIN_LOJA':
      return teceoBlueBackground;
    case 'COMPRADOR':
      return teceoBlueBackground;
    case 'ADMIN_MARCA':
      return teceoGreen;
    case 'VENDEDOR':
      return teceoGreen;
    default:
      return teceoGraySecondary;
  }
};

export const sleep = (delay = 2000) =>
  new Promise((resolve) => {
    setTimeout(resolve, delay);
  });

export const onScrollEndReload = <T = any>(
  event: React.SyntheticEvent | React.ChangeEvent<HTMLInputElement>,
  listPick: UseListPickActions<T>,
) => {
  const listboxNode = event.currentTarget;
  const remainingScrollDistance = Math.floor(
    listboxNode.scrollHeight - (listboxNode.scrollTop + listboxNode.clientHeight),
  );
  if (remainingScrollDistance <= 2 && !listPick.loading && listPick.hasNextPage) {
    listPick.next();
  }
};

export const isScrolledToEnd = (node: HTMLElement, threshold: number) =>
  node.scrollTop + node.clientHeight >= node.scrollHeight - threshold;

export const onScrollEndReloadForUseInfinityList = ({
  event,
  hasNextPage,
  loadMoreRows,
}: OnScrollEndReloadForUseInfinityListParams) => {
  const listboxNode = event.currentTarget;
  const remainingScrollDistance = Math.floor(
    listboxNode.scrollHeight - (listboxNode.scrollTop + listboxNode.clientHeight),
  );

  if (remainingScrollDistance <= 2 && hasNextPage) {
    loadMoreRows();
  }
};

export const prevent = (evt: React.SyntheticEvent) => {
  evt.preventDefault();
  evt.stopPropagation();
};
